












































import Dialog from '@/types/Dialog.interface'
import Vue from 'vue'
export default Vue.extend({
    props: {
        id: {
            type: Number,
            default: null
        }
    },
    computed: {
        buttonProps(): object {
            //  Check if we included buttons props
            const existing = this.dialog.buttonProps

            //  If we did, return those
            if (existing) return existing

            //  Else, use the defaults
            return {
                rounded: true,
                outlined: true,
                width: 140
            }
        },
        dialog(): Dialog {
            return this.$store.getters.dialogMessage[this.id]
        },
        buttonText(): string {
            //  If a dialog link exists, AND a dialog linkText does NOT exist, use 'Continue'
            if (this.dialog.link && !this.dialog.linkText) return 'Continue'

            //  If a dialog linkText exists, use it
            if (this.dialog.linkText) return this.dialog.linkText

            //  Else, return the default 'OK' content
            return 'OK'
        }
    },
    methods: {
        close(): void {
            this.$store.dispatch('dialogClose', 'MESSAGE')
        },
        submit(): void {
            //  If a link exists, navigate to the link
            if (this.dialog.link) this.$router.push(this.dialog.link)

            //  If a callback is set, use it
            if (this.dialog.callback) this.dialog.callback()

            //  Always close the dialog
            this.$store.dispatch('dialogClose', 'MESSAGE')
        },
        openLink(dialog: Dialog): void {
            this.close()

            //  If a callback function exists, use it
            if (dialog.buttonLinkCallback) dialog.buttonLinkCallback()
            //  Else, if the 'new tab' param is set, open a new browser window
            else if (dialog.buttonNewTab) window.open(dialog.buttonLink, '_blank')
            //  Else, navigate to the button link
            else this.$router.push(dialog.buttonLink)
        }
    }
})
